// The colours a Healthlink status wears, keyed by what it means rather than by which
// flow it came from. Referrals and eLab orders have different statuses and the same four
// meanings, and both render them with the app's shared Pill.
//
// Values are the referral palette, which the referral table and the CDM submission
// section already use — moved here so the flows cannot drift rather than restyled.
const TONE_COLORS = {
  positive: {
    color: "var(--green-900)",
    bg: "#e7efeb",
    border: "var(--green-900)",
  },
  pending: {
    color: "#756800",
    bg: "#efefe7",
    border: "#756800",
  },
  info: {
    color: "#3b5bdb",
    bg: "#f0f4ff",
    border: "#3b5bdb",
  },
  negative: {
    color: "#b70000",
    bg: "#ffe8e8",
    border: "#b70000",
  },
  neutral: {
    color: "var(--gray-600)",
    bg: "var(--gray-100)",
    border: "var(--gray-300)",
  },
};

export const getHealthlinkStatusColors = (tone) =>
  TONE_COLORS[tone] ?? TONE_COLORS.neutral;
